// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"profile-image_profileImage__2XnLf","picturePlaceholder":"profile-image_picturePlaceholder__RHExh"};